var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolCreateThreshold = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  viewBox: "0 0 25 25",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m18.857 16.217 2.497-2.497 2.497 2.497M18.857 20.223l2.497 2.497 2.497-2.497"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.89 6.56 11.83 16.622a.669.669 0 0 1-.34.181l-3.834.767a.669.669 0 0 1-.787-.787l.767-3.832a.669.669 0 0 1 .183-.341l10.06-10.061a2.83 2.83 0 0 1 4 0l.011.012a2.828 2.828 0 0 1 0 4Z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.5,
  strokeLinecap: "square",
  d: "m9.609 12.653 2.338 2.338"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 23.71H3a2.875 2.875 0 0 1-2.875-2.876v-1.438a.875.875 0 1 1 1.75 0v1.438c0 .622.504 1.125 1.125 1.125h2a.875.875 0 0 1 0 1.75ZM.125 15.145v-6.5a.875.875 0 1 1 1.75 0v6.5a.875.875 0 0 1-1.75 0Zm0-10.75V3A2.875 2.875 0 0 1 3 .125h2.043a.875.875 0 1 1 0 1.75H3c-.621 0-1.125.504-1.125 1.125v1.396a.875.875 0 0 1-1.75 0ZM9.293.125h2.234a.875.875 0 1 1 0 1.75H9.293a.875.875 0 0 1 0-1.75Z",
  fill: "currentColor",
  fillRule: "nonzero"
}))));
export { SvgToolCreateThreshold as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-create-threshold.svg";